import React from "react";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";
import {
    StyledLabel,
    StyledSelectInput,
    StyledTextInput,
} from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { ArrowDownIcon } from "@components/Common/SvgIcons/ArrowDownIcon";
import { components } from "react-select";
import { SupportCodeModal } from "./SupportCodeModal";
import { ipMatchWord } from "@constants/index";

type YavinConfigType = {
    setIsEdited: Function;
    isConsult: boolean;
    setMode: Function;
    mode: any;
    inputIp: boolean;
    setInputIp: Function;
    ipExist: boolean;
    ipAddress: string;
    setIpAddress: Function;
    isConfig: boolean;
    keyValue: any;
    setKey: Function;
    inputKey: boolean;
    setInputKey: Function;
    serialNumber: any;
    setSerialNumber: Function;
    inputSerialNumber: boolean;
    setInputSerialNumber: Function;
    communication: any;
    setCommunication: Function;
    port: any;
    setPort: Function;
    portSelectInput: boolean;
    setPortSelectInput: Function;
};

export function YavinConfig({
    setIsEdited,
    isConsult,
    setMode,
    mode,
    inputIp,
    setInputIp,
    ipExist,
    ipAddress,
    setIpAddress,
    keyValue,
    setKey,
    inputKey,
    setInputKey,
    serialNumber,
    setSerialNumber,
    inputSerialNumber,
    setInputSerialNumber,
    communication,
    setCommunication,
    port,
    setPort,
    portSelectInput,
    setPortSelectInput,
}: YavinConfigType) {
    const { t } = useTranslation();
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [, setIsConfigurationModalOpened] = React.useState<boolean>(false);
    const [codeSupport, setCodeSupport] = React.useState<string>("");
    const [isValidCode, setIsValidCode] = React.useState(false);
    let communications = [
        { label: "Local", value: "Local" },
        { label: "Cloud", value: "Cloud" },
    ];

    const DropdownIndicator = (props: any) => {
        return isValidCode === true || codeSupport === "" ? (
            <span
                onClick={() => {
                    setIsModalOpened(true);
                }}
                style={{
                    color: "hsl(0,0%,80%)",
                    width: "38px",
                }}
            >
                <ArrowDownIcon
                    fill="currentColor"
                    style={{ marginLeft: "8px" }}
                />
            </span>
        ) : (
            <components.DropdownIndicator {...props}>
                <ArrowDownIcon fill="currentColor" />
            </components.DropdownIndicator>
        );
    };
    return (
        <React.Fragment>
            <AvForm>
                <AvGroup>
                    <StyledLabel
                        htmlFor="payment type"
                        className="required__clz mt-3"
                    >
                        {t("Mode")}
                    </StyledLabel>
                    <StyledSelectInput
                        disabled
                        components={{ DropdownIndicator }}
                        className={classnames("mnt_drp_mode", {
                            readOnly__clz: isConsult,
                        })}
                        name="mode"
                        required
                        options={
                            codeSupport === ""
                                ? []
                                : [
                                      {
                                          label: "Test",
                                          value: "Test",
                                      },
                                      {
                                          label: "Production",
                                          value: "Production",
                                      },
                                  ]
                        }
                        placeholder={t("Select")}
                        onChange={(e: any) => {
                            setMode(e.label);
                            setIsEdited(true);
                        }}
                        value={{ label: mode, value: mode }}
                        onFocus={() => {
                            if (codeSupport === "") {
                                setIsModalOpened(true);
                            }
                        }}
                    />
                </AvGroup>
                <AvGroup>
                    <StyledLabel className="mt-3 required__clz" htmlFor="text">
                        {t("Port number")}
                    </StyledLabel>
                    <AvField
                        className={classnames("mnt_inp_portNumber", {
                            invalid__clz: portSelectInput,
                            readOnly__clz: isConsult,
                        })}
                        autocomplete="off"
                        id="port"
                        name="port"
                        placeholder={t("Write")}
                        type="number"
                        onChange={(e: any) => {
                            setPortSelectInput(false);
                            setPort(e.target.value);
                            setIsEdited(true);
                        }}
                        value={port}
                    />

                    {portSelectInput && (
                        <div
                            style={{
                                width: "100%",
                                marginTop: "0.25rem",
                                fontSize: "80%",
                                color: "#f46a6a",
                            }}
                        >
                            {t("Please select a port number")}
                        </div>
                    )}
                </AvGroup>
                <AvGroup>
                    <StyledLabel
                        htmlFor="example-input"
                        className="required__clz mt-3"
                    >
                        {t("Communication")}
                    </StyledLabel>
                    <StyledSelectInput
                        name="communications_input"
                        id="communications_input"
                        options={communications}
                        onChange={(e: any) => {
                            setCommunication(e.label);
                            setInputIp(false);
                            setInputKey(false);
                            setInputSerialNumber(false);
                            setIpAddress("");
                            setIsEdited(true);
                        }}
                        placeholder={t("Select")}
                        value={
                            communication !== ""
                                ? {
                                      value: communication,
                                      label: communication,
                                  }
                                : null
                        }
                        noOptionsMessage={() => t("No options")}
                        maxMenuHeight="90px"
                        className={classnames("mnt_drp_communication", {
                            readOnly__clz: isConsult,
                        })}
                    />
                </AvGroup>{" "}
                {communication === "Local" ? (
                    <AvGroup>
                        <StyledLabel
                            htmlFor="example-input"
                            className="mt-3 required__clz"
                        >
                            {t("IP address")}
                        </StyledLabel>
                        <AvField
                            className={classnames("mnt_inp_ipAdress", {
                                input__clz: inputIp || ipExist,
                                readOnly__clz: isConsult,
                            })}
                            autocomplete="off"
                            id="ipAddress"
                            name="ipAddress"
                            placeholder={t("Write")}
                            type="text"
                            onChange={(e: any) => {
                                setIpAddress(e.target.value);
                                if (
                                    !e.target.value.match(ipMatchWord) &&
                                    e.target.value !== ""
                                ) {
                                    setInputIp(true);
                                } else {
                                    setInputIp(false);
                                }
                                setIsEdited(true);
                            }}
                            value={ipAddress}
                        />
                        {inputIp || ipExist ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t(
                                    ipAddress === ""
                                        ? "Please enter a IP address"
                                        : !ipAddress.match(ipMatchWord)
                                        ? "IP address is invalid"
                                        : ipExist
                                        ? "The ip address is already exists"
                                        : ""
                                )}
                            </div>
                        ) : null}
                    </AvGroup>
                ) : (
                    <React.Fragment>
                        <AvGroup>
                            <StyledLabel
                                htmlFor="text"
                                className="mt-3 required__clz"
                            >
                                {t("Key")}
                            </StyledLabel>
                            <StyledTextInput
                                id="Key-input"
                                name="Key-input"
                                placeholder={t("Write")}
                                value={keyValue}
                                onChange={(e: any) => {
                                    setKey(e.target.value.trim());
                                    setInputKey(false);
                                    setIsEdited(true);
                                }}
                                className={classnames("mnt_inp_Key", {
                                    input__clz: inputKey,
                                    readOnly__clz: isConsult,
                                })}
                            />
                            {inputKey ? (
                                <div
                                    style={{
                                        width: "100%",
                                        marginTop: "0.25rem",
                                        fontSize: "80%",
                                        color: "#f46a6a",
                                    }}
                                >
                                    {t("Please enter a key")}
                                </div>
                            ) : null}
                        </AvGroup>
                        <AvGroup>
                            <StyledLabel
                                htmlFor="text"
                                className="mt-3 required__clz"
                            >
                                {t("TPE Serial Number")}
                            </StyledLabel>
                            <StyledTextInput
                                type="text"
                                id="serial-number"
                                name="serial-number"
                                placeholder={t("Write")}
                                value={serialNumber}
                                onChange={(e: any) => {
                                    setSerialNumber(e.target.value.trim());
                                    setInputSerialNumber(false);
                                    setIsEdited(true);
                                }}
                                className={classnames("mnt_inp_Key", {
                                    input__clz: inputSerialNumber,
                                    readOnly__clz: isConsult,
                                })}
                            />
                            {inputSerialNumber ? (
                                <div style={{ color: "red" }}>
                                    {t("Please enter a TPE serial number")}
                                </div>
                            ) : null}
                        </AvGroup>
                    </React.Fragment>
                )}
            </AvForm>
            {isModalOpened ? (
                <SupportCodeModal
                    isModalOpened={isModalOpened}
                    setIsModalOpened={setIsModalOpened}
                    codeSupport={codeSupport}
                    setCodeSupport={setCodeSupport}
                    isValidCode={isValidCode}
                    setIsValidCode={setIsValidCode}
                    isConfig={false}
                    setIsModalConfigOpened={setIsConfigurationModalOpened}
                />
            ) : null}
        </React.Fragment>
    );
}
